import { ACTIVITY_TYPES } from "Constants/constants";

export const OVERLAY_ACTIVITY_TYPES = [
  ACTIVITY_TYPES.ENVIRONMENT.PUSH,
  ACTIVITY_TYPES.ENVIRONMENT.MERGE,
  ACTIVITY_TYPES.ENVIRONMENT.SYNCHRONIZE,
  ACTIVITY_TYPES.ENVIRONMENT.REDEPLOY,
  ACTIVITY_TYPES.ENVIRONMENT.RESOURCES.UPDATE,
  ACTIVITY_TYPES.ENVIRONMENT.SUBSCRIPTION.UPDATE
];

export const ALERT_ACTIVITY_TYPES = [ACTIVITY_TYPES.ENVIRONMENT.ALERT];

export const colorBands = [
  "#653193",
  "#E35F94",
  "#3A7DFF",
  "#FF7F55",
  "#38485E",
  "#EEBC08",
  "#97DC97",
  "#39BEBE",
  "#6046FF",
  "#AE82FF"
];
